import Router from './config/router'

const App = () => {
  return <Router />
}

export default App
